import { BidderSeat } from '@pubstack/common/src/bidder-seat'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { Tag } from '~/components/Tag'
import { seatTypeIcon, seatTypeLabel } from './seatType'

/**
 * How a seat is integrated, as a chip: the catalog's glyph for that integration, and its name.
 *
 * Shared by the seat list and the seat's own header so the two never drift — the header used to print a
 * fixed "Prebid bidder" that said nothing about the seat it belonged to.
 */
export const SeatTypeChip: FunctionComponent<{ seat: BidderSeat }> = ({ seat }) => {
  const icon = seatTypeIcon(seat)
  return (
    // Grey, and `font-normal` explicitly: `Fonts.P3` sets no weight, so a chip in a table's first cell
    // inherited the bold that `Table` gives that cell and read as loud as the bidder's own name. The
    // integration is context for the row, not a claim about it — it says what a seat *is*, and nothing
    // is wrong or noteworthy about either answer.
    <Tag className={'items-center gap-1 font-normal'} color={Colors.Ash}>
      {icon && <Icon width="12px" height="12px" name={icon} />}
      {seatTypeLabel(seat)}
    </Tag>
  )
}
